import { combineReducers } from 'redux';
import _omit from 'lodash/omit';

import errors from './errors';

import {
  ACTION_LOAD_WIRE__SUCCESS,
  ACTION_LOAD_WIRE__FAIL,

  ACTION_EDIT_WIRE__SUCCESS,
} from '../actionTypes';


export const defaultWire = {
  bankIban: '',
  bankName: '',
  bankBeneficiary: '',
  bankSwift: '',
  routingNumber: null,
};

const data = (state = defaultWire, action) => {
  switch (action.type) {
    case ACTION_EDIT_WIRE__SUCCESS:
    case ACTION_LOAD_WIRE__SUCCESS:
      return action.payload.wire;

    case ACTION_LOAD_WIRE__FAIL:
      return null;

    default:
      return state;
  }
};

export default combineReducers({
  data,
  errors,
});
